module.exports = __webpack_public_path__ + "img/840.ed4b268b.svg";